import { ReactComponent as ArrorRight } from '../images/arrow-right.svg';
import ImgFEA from '../images/Imagen_FEA.png';
import MockupMoontrip from '../images/mockups/Mockup-moontrip.png';
import VostaniLogo from '../images/vostani-portfolio.png';
import { 
  Portafolio,
  Title,
  Description,
  MoonTripContainer,
  MoontripImgBox,
  MoonTripContentBox,
  TitleMoonTrip,
  DescriptionMoonTrip,
  ButtonBox,
  MoontripLink,
  Proyectos,
  Proyecto,
  Figura,
  Imagen,
  FigCaption,
  H2,
  DivCentrar,
  Boton,
  SpanIcono
} from '../styles/portfolio.styles';

const Portfolio = () => {
  return (
    <Portafolio>
      <Title>Mi trabajo independiente</Title>
      <Description>
        A lo largo de mi carrera he tenido la oportunidad de colaborar en diferentes sectores, como seguros, banca, ecommerce y logística. Aunque no he hecho muchos proyectos como freelancer, en este espacio quiero mostrarte algunos de los trabajos que he realizado por mi cuenta. ¡Espero que te gusten!
      </Description>

      <MoonTripContainer>
        <MoontripImgBox>
          <Imagen alt="Moontrip-app" className='moontrip-mockup' src={MockupMoontrip} />
        </MoontripImgBox>

        <MoonTripContentBox>
          <TitleMoonTrip>MoonTrip</TitleMoonTrip>
          <DescriptionMoonTrip>
            MoonTrip nació de la necesidad de sustituir las herramientas financieras genéricas y las hojas de cálculo complejas por una solución móvil ágil, intuitiva y centrada en el usuario. Concibí y diseñé esta plataforma para transformar la gestión del capital personal en una experiencia clara, accesible y libre de fricción.
          </DescriptionMoonTrip>

          <DescriptionMoonTrip>
            Como único desarrollador a cargo de todo el ciclo de vida del producto —desde la arquitectura de datos y la lógica del servidor hasta la interfaz de usuario (UI/UX)—, aseguré un alto estándar de rendimiento, seguridad y usabilidad. Cada componente, desde los flujos de registro de transacciones hasta los tableros de analítica visual, fue construido estratégicamente para ofrecer una experiencia fluida y escalable.
          </DescriptionMoonTrip>

          <DescriptionMoonTrip>
            La gestión eficiente de datos e indicadores clave no es un lujo, es una ventaja competitiva. MoonTrip demuestra mi capacidad para transformar requerimientos complejos en herramientas digitales de alto valor. Si tu negocio o proyecto requiere una aplicación web o móvil personalizada, desarrollada con rigor técnico y centrada en la conversión, diseñemos la solución ideal.
          </DescriptionMoonTrip>

          <ButtonBox>
            <MoontripLink href="https://moontrip.mx/" target='_blank' rel='noreferrer'>
              Ver caso de estudio
            </MoontripLink>
          </ButtonBox>

        </MoonTripContentBox>
      </MoonTripContainer>

      <Proyectos>
        <Proyecto>
          <Figura className='fig-image'>
            <Imagen alt="formula-entre-amigos" className='project-thumb' src={ImgFEA} />
            <FigCaption className='overlay overlay--blur'>
              <H2>La mejor merch de Fórmula 1 de todo México, donde encontrarás podcasts y memes</H2>
              <DivCentrar>
                <Boton href='https://formulaentreamigos.com/' target='_blank' rel='noreferrer'>
                  <span>Ver sitio web</span>
                  <SpanIcono>
                    <ArrorRight />
                  </SpanIcono>
                </Boton>
              </DivCentrar>
            </FigCaption>
          </Figura>
        </Proyecto>

        <Proyecto>
          <Figura className='fig-image'>
            <Imagen alt="App gastos" className='project-thumb' src={VostaniLogo} />
            <FigCaption className='overlay overlay--blur'>
              <H2>Ropa fitness de la más alta calidad. For those who never stop.</H2>
              <DivCentrar>
                <Boton href='https://vostani.com.mx' target='_blank' rel='noreferrer'>
                  <span>Ver sitio web</span>
                  <SpanIcono>
                    <ArrorRight />
                  </SpanIcono>
                </Boton>
              </DivCentrar>
            </FigCaption>
          </Figura>
        </Proyecto>
      </Proyectos>
    </Portafolio>
  );
}

export default Portfolio;